"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleValidateProductOptions;
const either_1 = require("../../../types/either");
const ValidateProductOptions_1 = require("../../../actions/ValidateProductOptions");
const updateProjectVersion_1 = __importDefault(require("../updateProjectVersion"));
const projectHelpers_1 = require("../../../utils/projectHelpers");
const __1 = require("..");
// this is used to update old color-series projects as we get them in cc... see https://github.com/ArtifactUprising/crud-core/pull/621/files#diff-663e06a98d4749237532a3e63724a6937da5cc5ff0680fb72e8fde7e2fe446a0R123
function handleValidateProductOptions(project, action, dependencies) {
  return __awaiter(this, void 0, void 0, function* () {
    if (!(0, ValidateProductOptions_1.isValidateProductOptions)(action)) {
      return (0, either_1.left)(new Error('Action does not match update project name schema'));
    }
    const {
      getART,
      getProduct
    } = dependencies;
    const artResult = yield getART(project.product.sku);
    if (artResult.isLeft()) {
      return (0, either_1.left)(artResult.value);
    }
    const productResult = yield getProduct(project.product.sku);
    if (productResult.isLeft()) {
      return (0, either_1.left)(productResult.value);
    }
    if ((0, projectHelpers_1.hasInvalidProductOption)(project, artResult.value)) {
      const newProject = (0, updateProjectVersion_1.default)(project, action);
      // We don't want people to be able to undo this action
      newProject.versionStack = [newProject.version];
      return (0, __1.maybeUpdateProductOptions)(newProject, artResult.value, action.timestamp, productResult.value);
    }
    return (0, either_1.right)({
      updatedProject: project,
      updatedEntities: []
    });
  });
}